import { anchorUiPath } from "@/utils/anchor-plan/helpers";

/** Сегмент settings path (відповідає `data-tab` у Налаштуваннях). */
export const SETTINGS_PATH_SEGMENT_DEFAULT = "budget";

/** Сегмент URL → внутрішня назва секції (`dashboard` лишається slug для hub у коді; у URL використовується `plans`). */
export function pathSegmentToSection(segment) {
  if (!segment) return null;
  if (segment === "plans" || segment === "dashboard") return "dashboard";
  if (segment === "history") return "dashboard";
  return segment;
}

/** Внутрішня секція → останній сегмент шляху в UI (крім `settings`, де ще вкладки). */
export function sectionToUrlSegment(section) {
  if (!section) return "";
  if (section === "dashboard") return "plans";
  return section;
}

/**
 * @param {{ projectId: string | null; section?: string | null; planId?: string | null; extraQuery?: string; settingsTab?: string | null }} p
 */
export function buildProjectHref(p) {
  const { projectId, section, planId, extraQuery, settingsTab } = p;
  if (!projectId) return anchorUiPath("");
  let rel = `project/${projectId}`;
  if (section === "settings") {
    const tab = settingsTab || SETTINGS_PATH_SEGMENT_DEFAULT;
    rel += `/settings/${encodeURIComponent(tab)}`;
  } else if (section) {
    rel += `/${sectionToUrlSegment(section)}`;
  }
  const q = [];
  if (planId) q.push(`plan=${encodeURIComponent(planId)}`);
  if (extraQuery) q.push(extraQuery);
  if (q.length) rel += `?${q.join("&")}`;
  return anchorUiPath(rel);
}

/**
 * @param {string} pathname
 * @param {string} search - query string including ?
 * @param {boolean} legacyProjectHtml
 * @returns {{ projectId: string | null; section: string | null; settingsTab: string | null; planId: string | null }}
 */
export function parseProjectPathFromLocation(
  pathname,
  search,
  legacyProjectHtml,
) {
  const path = (pathname || "").replace(/\/+$/, "");
  const params = new URLSearchParams(search || "");
  const planId = params.get("plan");

  const settingsMatch = path.match(
    /\/project\/([^/]+)\/settings(?:\/([^/]+))?$/,
  );
  if (settingsMatch) {
    const projectId = settingsMatch[1];
    const rawTab = settingsMatch[2];
    let settingsTab = SETTINGS_PATH_SEGMENT_DEFAULT;
    if (rawTab && /^[\w-]+$/.test(rawTab)) settingsTab = rawTab;
    return { projectId, section: "settings", settingsTab, planId };
  }

  const m = path.match(/\/project\/([^/]+)(?:\/([^/]+))?$/);
  if (m) {
    const raw = m[2] || null;
    const sec = pathSegmentToSection(raw);
    return { projectId: m[1], section: sec, settingsTab: null, planId };
  }
  const pid = params.get("p") || params.get("id");
  if (pid && legacyProjectHtml) {
    const rawS = params.get("s") || null;
    const sec = pathSegmentToSection(rawS);
    return { projectId: pid, section: sec, settingsTab: null, planId };
  }
  return { projectId: null, section: null, settingsTab: null, planId: null };
}

export function parseProjectPath() {
  return parseProjectPathFromLocation(
    typeof window !== "undefined" ? window.location.pathname : "",
    typeof window !== "undefined" ? window.location.search : "",
    typeof window !== "undefined" &&
      window.location.pathname.includes("project.html"),
  );
}
